/* eslint-disable class-methods-use-this */
import Component from '../components/forms/FormGeneric';

export default class giftCardFormGeneric extends Component {
    init() {
        super.init();
        this.event('submit', this.giftCardFormGenericSubmit.bind(this));
    }

    validateInputFields() {
        $(this.$el).find('input:visible, select:visible').each((index, input) => {
            var $this = $(input);
            var value = $this.val();
            var errorMessage = null;
            if (!value) {
                errorMessage = $this.data('missing-error');
            } else {
                var customerRegExp = new RegExp($this.attr('pattern'), '');
                if (!customerRegExp.test(value)) {
                    errorMessage = $this.data('parse-error');
                }
            }

            if (errorMessage) {
                $this.closest('.form-group').find('.invalid-feedback').text(errorMessage);
                $this.closest('.form-group').addClass('error-field');
                $this.addClass('is-invalid');
            } else {
                $this.closest('.form-group').removeClass('error-field');
            }
        });
    }

    /**
     *
     * @param {boolean} hide - true to hide payment method, false to show
     */
    updateApllicablePaymentMethods(hide) {
        var allMethods = $('li.paymentMethod');
        var incompatibleMethods = $('#gcIncompatiblePaymentMethods').text().trim().toLowerCase();
        for (let index = 0; index < allMethods.length; index++) {
            const method = allMethods[index];
            var pm = $(method);
            var pmName = pm.attr('class').split(/\s+/)[0];
            if (incompatibleMethods.includes(pmName)) {
                if (hide) {
                    pm.addClass('hide');
                } else {
                    pm.removeClass('hide');
                }
            }
        }
    }

    giftCardFormGenericSubmit(event) {
        event.preventDefault();
        $('.gift-card-payment').spinner().start();
        var $form = this.$el;
        $('.s-giftcard__formFields .error-info').html('');
        this.validateInputFields();
        if (!$form.find('input.is-invalid').length && !$form.find('select.is-invalid').length) {
            $.ajax({
                url: $form.attr('action'),
                type: 'post',
                data: $form.serialize(),
                context: this,
                success: function (response) {
                    if (response && response.data && response.data.success) {
                        var $parsedHtml = this.parseHtml(response.renderedTemplate);
                        $('.js-giftcard-container .s-giftcard_section_ajax').html($parsedHtml.body);
                        var $giftcardFields = $('.s-giftcard__formFields');
                        $giftcardFields.addClass('hide');
                        // clear form fields
                        if ($('#gcNumber').length > 0) $('#gcNumber').val('');
                        if ($('#gcPin').length > 0) $('#gcPin').val('');
                        if ($giftcardFields.length > 0) $giftcardFields.children('div.error-info').html('');
                        $('.paypal-tab, .g-tabs-chip.klarna-payment-item, .g-accordion-item.klarna_payments-content, .g-accordion-item.paypal-content').addClass('hide');
                        $('.nav-item.paymetric-tab a.nav-link').trigger('click');
                        $('.b-checkout_subheader-express-login').addClass('hide');

                        // hide non applicable payment methods
                        this.updateApllicablePaymentMethods(true);
                        // When selected method is hidden, preselect the first visible method
                        if ($('.nav-item a.nav-link.active[aria-selected="true"]:visible').length === 0) {
                            if ($('.nav-item a.nav-link:visible').length) {
                                $('.nav-item a.nav-link:visible').first().trigger('click');
                            }
                        }
                        if (response.gcResults && response.gcResults.gcPaymentInstruments && response.gcResults.gcPaymentInstruments.length > 0) {
                            if (!$('.payment-information').hasClass('gc-pay-applied')) {
                                $('.payment-information').addClass('gc-pay-applied');
                            }
                        } else if ($('.payment-information').hasClass('gc-pay-applied')) {
                            $('.payment-information').removeClass('gc-pay-applied');
                        }

                        if (response.data.isOrderTotalRedeemed) {
                            $('.credit-card-selection-new .tab-pane').removeClass('active');
                            $('.payment-information .g-tabs-chip.nav-item .nav-link').removeClass('active');
                            $('.b-payement-tab-emea').addClass('hide');
                            $('.payment-information').addClass('gc-pay');
                            $('.b-payment-heading').addClass('hide');
                            $('#selectedPaymentOption').val('GIFT_CARD');
                        }
                        if (response && response.gcResults && response.gcResults.gcPaymentInstruments) {
                            var gcAppliedAmount = $('.js-gift_card_applied_amount');
                            var htmlToAppend = '';
                            for (var i = 0; i < response.gcResults.gcPaymentInstruments.length; i++) {
                                var gcPaymentInstrument = response.gcResults.gcPaymentInstruments[i];
                                htmlToAppend += `<div class="gift_card_applied_amount active">
                                    <span class="order-summary_itemsattr">
                                    <span class="order-receipt-label gc-row">${gcAppliedAmount.data('giftcard-title')} ${gcPaymentInstrument.maskedGcLastFourNumber}:</span></span>
                                    <span class="order-summary_itemsvalue">
                                        <span class="text-right gc-row">- <span class="gc-applied-amount">${gcPaymentInstrument.appliedAmount}</span></span>
                                    </span></div>`;
                            }
                            gcAppliedAmount.empty().append(htmlToAppend);
                        }

                        if ($('div#applepay-content').length > 0) {
                            window.location.reload();
                        }

                        $('body').trigger('checkout:updateCheckoutView', {
                            order: response.data.order,
                            customer: response.data.customer,
                            gcResults: response.gcResults ? response.gcResults : ''
                        });
                    } else if (response && response.error && response.cartError) {
                        //  Redirect customer to Cart page if there is cart error.
                        if (response.cartError) {
                            window.location.href = response.redirectUrl;
                        }
                    } else {
                        $('.s-giftcard__formFields .error-info').html(response.data.message || response.data.errorMessage);
                    }
                    $('.gift-card-payment').spinner().stop();
                },
                error: function (err) {
                    $('.gift-card-payment').spinner().stop();
                    if (err.responseJSON && err.responseJSON.csrfError && err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        $('.s-giftcard__formFields .error-info').html($('#gc-generic-error').text());
                    }
                }
            });
        } else {
            $('.gift-card-payment').spinner().stop();
        }
    }

    parseHtml(html) {
        var $html = $('<div>').append($.parseHTML(html));

        var body = $html.find('.s-giftcard_section_ajax');

        return { body: body };
    }

    handleGiftCardSectionDisplay(data) {
        var $giftcardFields = $('.s-giftcard__formFields');
        if (data && data.renderedTemplate) {
            $('.js-giftcard-container .s-giftcard_section_ajax').html($(data.renderedTemplate).find('.s-giftcard_section_ajax').html());
            if ($('.b-giftcard_applied_card').length) {
                $giftcardFields.addClass('hide');
                // clear form fields
                if ($('#gcNumber').length > 0) $('#gcNumber').val('');
                if ($('#gcPin').length > 0) $('#gcPin').val('');
                if ($giftcardFields.length > 0) $giftcardFields.children('div.error-info').html('');
            } else {
                $giftcardFields.removeClass('hide');
            }
        }
        if (data.gcResults && data.gcResults.gcPaymentInstruments && data.gcResults.gcPaymentInstruments.length > 0) {
            var gcAppliedAmount = $('.js-gift_card_applied_amount');
            var htmlToAppend = '';
            for (var i = 0; i < data.gcResults.gcPaymentInstruments.length; i++) {
                var gcPaymentInstrument = data.gcResults.gcPaymentInstruments[i];
                htmlToAppend += `<div class="gift_card_applied_amount active">
                    <span class="order-summary_itemsattr">
                    <span class="order-receipt-label gc-row">${gcAppliedAmount.data('giftcard-title')} ${gcPaymentInstrument.maskedGcLastFourNumber}:</span></span>
                    <span class="order-summary_itemsvalue">
                        <span class="text-right gc-row">- <span class="gc-applied-amount">${gcPaymentInstrument.appliedAmount}</span></span>
                    </span></div>`;
            }
            gcAppliedAmount.empty().append(htmlToAppend);
            if (!$('.payment-information').hasClass('gc-pay-applied')) {
                $('.payment-information').addClass('gc-pay-applied');
            }
            if (data.gcResults.isOrderTotalRedeemed) {
                $('.payment-information').addClass('gc-pay');
                $('.b-payement-tab-emea').addClass('hide');
                $('.b-payment-heading').addClass('hide');
            } else {
                $('.payment-information').removeClass('gc-pay');
                $('.b-payement-tab-emea').removeClass('hide');
                $('.b-payment-heading').removeClass('hide');
                $('.nav-item.paymetric-tab a.nav-link').trigger('click');
                // When selected method is hidden, preselect the first visible method
                if ($('.nav-item a.nav-link.active[aria-selected="true"]:visible').length === 0) {
                    if ($('.nav-item a.nav-link:visible').length) {
                        $('.nav-item a.nav-link:visible').first().trigger('click');
                    }
                }
            }
        } else {
            if ($('.payment-information').hasClass('gc-pay-applied')) {
                $('.payment-information').removeClass('gc-pay-applied');
            }
            $('.gift_card_applied_amount').removeClass('active');
            $('.payment-information').removeClass('gc-pay');
            $('.b-payement-tab-emea').removeClass('hide');
            // unhide hidden payment methods
            this.updateApllicablePaymentMethods(false);
            $('.b-payment-heading').removeClass('hide');
            $('.nav-item.paymetric-tab a.nav-link').trigger('click');
            // When selected method is hidden, preselect the first visible method
            if ($('.nav-item a.nav-link.active[aria-selected="true"]:visible').length === 0) {
                if ($('.nav-item a.nav-link:visible').length) {
                    $('.nav-item a.nav-link:visible').first().trigger('click');
                }
            }

            $('body').trigger('checkout:updateCheckoutView', {
                order: data.order,
                customer: data.customer,
                gcResults: data.gcResults ? data.gcResults : ''
            });
        }
        if (!($('.js-giftCard-section').is(':checked')) || $('.gift_card_applied_amount.active').length > 0) {
            $giftcardFields.addClass('hide');
            // clear form fields
            if ($('#gcNumber').length > 0) $('#gcNumber').val('');
            if ($('#gcPin').length > 0) $('#gcPin').val('');
            if ($giftcardFields.length > 0) $giftcardFields.children('div.error-info').html('');
        } else {
            $giftcardFields.removeClass('hide');
        }
        if (data.basketHasGiftCard) {
            $('.js-giftcard-container').remove();
        }
    }
}
